var angular = require('angular');

const SERVER = 'http://159.203.222.219:5253/'; // localhost:5253
const API_ROOT = SERVER + 'api/';

angular.module('tristarApp.services', [])

// ProductService
.service('ProductService', ['$http', '$q', function($http, $q) {

	var self = this;
	self.savedSearchFilters = {};

	this.setSearchFilters = function(data) {
		self.savedSearchFilters = data;
	}

	this.getSearchFilters = function() {
		return self.savedSearchFilters;
	}

	// fetch the specials from json
	this.getSpecials = function() {

		// if the specials are fetched already simply return the promise
		if (self.specials) {
			return $q.when(self.specials);
		}

		// return the promise with specials
		return $http.get(API_ROOT + 'product/specials').then(function(response) {
			self.specials = response.data;
			return response.data;
		});
	}

	// get products from json
	this.getProducts = function() {

		// if the specials are fetched already simply return the promise
		if (self.products) {
			return $q.when(self.products);
		}

		// return the promise with specials
		return $http.get(API_ROOT + 'product/all').then(function(response) {
			self.products = response.data;
			return response.data;
		});
	}

	this.getCategories = function() {

		// if the specials are fetched already simply return the promise
		if (self.categories) {
			return $q.when(self.categories);
		}

		// return the promise with specials
		return this.getProducts().then(function(products) {
			var categories = _.pluck(_.uniq(products, function(x) {
				return x.category.toUpperCase();
			}), 'category');

			self.categories = _.map(categories, function(c) {
				return {
					key: c,
					value: c
				};
			})

			return self.categories;
		});
	}

	// search products based on criteria
	this.getSearchResults = function(filters) {
		console.info(filters);
		// return the promise with specials
		return this.getProducts().then(function(products) {

			// self.searchResults = products;

			self.searchResults = _.filter(products, function(product) {
				var include = false;
				// filter by category
				if (filters.category) {
					include = filters.category === product.category;
				}
				// // if the category is blank that means all the items in that category
				if (filters.category === '') {
					include = true;
				}
				// filter by name
				if (include && filters.name) {
					include = new RegExp(filters.name, 'i').test(product.name);
				}
				return include;
			});

			return self.searchResults;
		});
	}

}])

.service('ClientService', ['$http', '$q', function($http, $q) {

	var self = this;


	self.add = function(data) {

		if (!data) {
			console.error('data is empty');
			return $q.when({ error: true });
		} else {

			// post the form and return the promise
			return $http.post(API_ROOT + 'client', JSON.stringify(data)).then(function(response) {
				console.log('response', response);
				return $q.when({
					submitted: true,
					status: !response.data.error
				});
			});

		}
	}

}])

;



/*****************
 ** WEBPACK FOOTER
 ** ./js/services.js
 ** module id = 5
 ** module chunks = 0
 **/